import { UserStyleService } from './service/UserStyleService';
import { showStylesPopup } from './view';
import { UserStylesTab } from './view/UserStylesTab';
import { UserStyleHandler } from './handler/UserStyleHandler';
import { BUNDLE_KEY } from './constants';
/**
 * @class Oskari.mapframework.userstyle.UserStyleBundleInstance
 */
Oskari.clazz.define('Oskari.mapframework.userstyle.UserStyleBundleInstance', function () {
  this.service = null;
  this.handler = null;
  this.popupController = null;
  this.sandbox = null;
  this.loc = Oskari.getMsg.bind(null, this.getName());
}, {
  __name: BUNDLE_KEY,
  requestHandlers: {
    ShowUserStylesRequest: function ShowUserStylesRequest() {
      return Oskari.clazz.create('Oskari.mapframework.userstyle.request.ShowUserStylesRequestHandler', this);
    }
  },
  _startImpl: function _startImpl(sandbox) {
    var _this = this;
    this.sandbox = sandbox;
    this.service = new UserStyleService(sandbox);
    this.handler = new UserStyleHandler(this);
    sandbox.registerService(this.service);
    this.addTab();
    this.service.on('update', function (layerId) {
      return _this.updateStyleList(layerId);
    });
  },
  getSandbox: function getSandbox() {
    return this.sandbox;
  },
  getService: function getService() {
    return this.service;
  },
  updateStyleList: function updateStyleList(layerId) {
    if (!this.popupController) {
      return;
    }
    this.popupController.update({
      layerId: layerId
    });
  },
  cleanPopup: function cleanPopup() {
    if (this.popupController) {
      this.popupController.close();
    }
    this.popupController = null;
  },
  showPopup: function showPopup(requestOpts) {
    var _this2 = this;
    var id = requestOpts.id,
      addToLayer = requestOpts.addToLayer,
      layerId = requestOpts.layerId;
    var layerStyles = this.service.getStylesByLayer(layerId);
    var showEditor = typeof id !== 'undefined' || typeof addToLayer === 'number' || layerStyles.length === 0;
    var requestedLayer = addToLayer || layerId;
    var onClose = function onClose(wasEditor) {
      if (wasEditor === true && layerStyles.length > 1) {
        _this2.updateStyleList(requestedLayer);
        return;
      }
      _this2.cleanPopup();
    };
    var options = {
      id: id,
      layerId: requestedLayer,
      showEditor: showEditor
    };
    if (showEditor) {
      var _this$getSandbox$getS;
      options.geometryType = (_this$getSandbox$getS = this.getSandbox().getService('Oskari.mapframework.service.MapLayerService')) === null || _this$getSandbox$getS === void 0 || (_this$getSandbox$getS = _this$getSandbox$getS.findMapLayer(requestedLayer)) === null || _this$getSandbox$getS === void 0 ? void 0 : _this$getSandbox$getS.getGeometryType();
    }
    if (this.popupController) {
      this.popupController.update(options);
    } else {
      this.popupController = showStylesPopup(this.service, options, onClose);
    }
  },
  addTab: function addTab() {
    var _this3 = this;
    var myDataService = this.sandbox.getService('Oskari.mapframework.bundle.mydata.service.MyDataService');
    if (myDataService) {
      myDataService.addTab(this.getName(), this.loc('tab.title'), UserStylesTab, this.handler);
    } else {
      // Wait for the application to load all bundles and try again
      Oskari.on('app.start', function () {
        _this3.addTab();
      });
    }
  }
}, {
  extend: ['Oskari.BasicBundle'],
  protocol: ['Oskari.bundle.BundleInstance', 'Oskari.mapframework.module.Module']
});